(function ($) {
  if (!$) return;

  function syncVideos($carousel) {
    var $current = $carousel.find('.ugc-slider__cell.slick-center.slick-active');
    if (!$current.length) {
      $current = $carousel.find('.ugc-slider__cell.slick-current');
    }
    $carousel.find('video').each(function () {
      var video = this;
      var isCurrent = $current.length && $current[0].contains(video);
      if (isCurrent) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function initCarousel(carousel) {
    var $carousel = $(carousel);
    if ($carousel.hasClass('slick-initialized')) return;

    var loop = $carousel.data('loop') === true || $carousel.data('loop') === 'true';
    var autoplayAttr = $carousel.data('autoplay');
    var autoplay = autoplayAttr === true || autoplayAttr === 'true';
    var autoplaySpeed = parseInt($carousel.data('autoplaySpeed'), 10) || 3000;
    var slidesDesktop = parseInt($carousel.data('slidesDesktop'), 10) || 5;
    var slidesTablet = parseInt($carousel.data('slidesTablet'), 10) || 3;
    var slidesMobile = parseInt($carousel.data('slidesMobile'), 10) || 1;
    var centerPaddingDesktop = (parseInt($carousel.data('centerPaddingDesktop'), 10) || 0) + 'px';
    var centerPaddingMobile = (parseInt($carousel.data('centerPaddingMobile'), 10) || 0) + 'px';
    var rtl = window.theme && window.theme.config ? !!window.theme.config.rtl : false;

    // Videos may carry the native "autoplay" attribute and start playing
    // immediately, before Slick has decided which slide is centered.
    // Pause everything right away; syncVideos() resumes only the correct one.
    $carousel.find('video').each(function () {
      this.pause();
    });

    $carousel.on('qa:video-ready', function () {
      syncVideos($carousel);
    });

    $carousel.on('init afterChange', function () {
      syncVideos($carousel);
    });

    $carousel.slick({
      centerMode: true,
      centerPadding: centerPaddingDesktop,
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      infinite: loop,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      pauseOnHover: true,
      arrows: false,
      dots: false,
      draggable: true,
      swipe: true,
      focusOnSelect: true,
      rtl: rtl,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerMode: true,
            centerPadding: centerPaddingDesktop,
            slidesToShow: slidesTablet,
          },
        },
        {
          breakpoint: 749,
          settings: {
            centerMode: true,
            centerPadding: centerPaddingMobile,
            slidesToShow: slidesMobile,
          },
        },
      ],
    });
  }

  function init() {
    var carousels = document.querySelectorAll('.ugc-slider__carousel');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      initCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window.jQuery);
